import { clientUtils, trpc } from '@/utils/trpc'
import { useEffect, useState } from 'react'
import type { AirTableAdRecord, AirTableEmailRecord, AirtableLandingPageRecord } from '../../../../src/shared'
import { createBatchQueue } from './useBatchQueue'

const fetchAdTemplates = async (ids: string[]) => {
  const response = await clientUtils.batchAdTemplates.ensureData({
    ids,
  })
  return response
}

export const { addToQueue: addAdTemplateToQueue } = createBatchQueue<AirTableAdRecord>(fetchAdTemplates)

export const useAdTemplatePrefetch = () => {
  const [adTemplateId, setAdTemplateId] = useState<string | null>(null)
  const { setData } = trpc.useUtils().posts

  useEffect(() => {
    if (adTemplateId) {
      addAdTemplateToQueue(adTemplateId).then((result) => {
        const record = result[adTemplateId.toString()]
        setData(
          {
            adID: adTemplateId,
            limit: 1,
            Ready: true,
          },
          {
            nextCursor: 1,
            ATRecords: [record],
            TotalRecords: 0,
            hasAccess: true,
          },
        )
      })
    }
  }, [adTemplateId])

  return {
    prefetchAdTemplate: setAdTemplateId,
  }
}

const fetchLandingPageTemplates = async (ids: string[]) => {
  const response = await clientUtils.batchLandingPageTemplates.ensureData({
    ids,
  })
  return response
}

export const { addToQueue: addLandingPageTemplateToQueue } =
  createBatchQueue<AirtableLandingPageRecord>(fetchLandingPageTemplates)

export const useLandingPageTemplatePrefetch = () => {
  const [landingPageTemplateId, setLandingPageTemplateId] = useState<string | null>(null)
  const { setData } = trpc.useUtils().getLandingPageTemplateById
  useEffect(() => {
    if (landingPageTemplateId) {
      addLandingPageTemplateToQueue(landingPageTemplateId).then((result) => {
        const record = result[landingPageTemplateId.toString()]
        setData(
          {
            landingPageTemplateId: parseInt(`${landingPageTemplateId}`),
          },
          record,
        )
      })
    }
  }, [landingPageTemplateId])
  return {
    prefetchLandingPageTemplate: setLandingPageTemplateId,
  }
}

const fetchEmailTemplates = async (ids: string[]) => {
  const response = await clientUtils.batchEmailTemplates.ensureData({
    ids,
  })
  return response
}

export const { addToQueue: addEmailTemplateToQueue } = createBatchQueue<AirTableEmailRecord>(fetchEmailTemplates)

export const useEmailTemplatePrefetch = () => {
  const [emailTemplateId, setEmailTemplateId] = useState<string | null>(null)
  const { setData } = trpc.useUtils().getEmailTemplateById
  useEffect(() => {
    if (emailTemplateId) {
      addEmailTemplateToQueue(emailTemplateId).then((result) => {
        const record = result[emailTemplateId.toString()]
        setData(
          {
            emailTemplateId: parseInt(`${emailTemplateId}`),
          },
          record,
        )
      })
    }
  }, [emailTemplateId])
  return {
    prefetchEmailTemplate: setEmailTemplateId,
  }
}
